import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../../common/store/types';
import { WorkScheduleModel } from './types';
import { workScheduleActions } from './work-schedule.actions';

export interface IWorkScheduleState extends IState<WorkScheduleModel> {
  getById: GenericState<WorkScheduleModel>;
  createInstance: GenericState<WorkScheduleModel>;
  add: GenericState<WorkScheduleModel>;
  update: GenericState<WorkScheduleModel>;
  delete: GenericState<boolean>;
}

export const workScheduleInitialState: IWorkScheduleState = {
  getById: new GenericState<WorkScheduleModel>(),
  createInstance: new GenericState<WorkScheduleModel>(),
  add: new GenericState<WorkScheduleModel>(),
  update: new GenericState<WorkScheduleModel>(),
  delete: new GenericState<boolean>(),
};

const workScheduleReducers = [
  ...onApiCall<WorkScheduleModel>(workScheduleActions.getById, 'getById'),
  ...onApiCall<WorkScheduleModel>(
    workScheduleActions.createInstance,
    'createInstance',
  ),
  ...onApiCall<WorkScheduleModel>(workScheduleActions.add, 'add'),
  ...onApiCall<WorkScheduleModel>(workScheduleActions.update, 'update'),
  ...onApiCall<boolean>(workScheduleActions.delete, 'delete'),
];

export const workScheduleReducer = createReducer(
  workScheduleInitialState,
  ...workScheduleReducers,
) as ActionReducer<IWorkScheduleState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return workScheduleReducer(state, action);
}
